import { render, staticRenderFns } from "./WorkDocsDocumentTypeModal.vue?vue&type=template&id=6237d0f2&"
import script from "./WorkDocsDocumentTypeModal.vue?vue&type=script&lang=js&"
export * from "./WorkDocsDocumentTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports